<template>
  <form class="search-area">
    <b-form-row>
      <b-col class="form-group">
        <h3 class="common__search-title">Tutor</h3>
        <input
          v-model="conditions.tutorNameOrId"
          type="text"
          class="form-control w-50"
        >
      </b-col>
      <b-col>
        <h3 class="common__search-title">YearMonth</h3>
        <YearMonthInput v-model="conditions.yearMonth" />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col class="form-group">
        <h3 class="common__search-title">Position</h3>
        <PositionsInput v-model="conditions.positions"/>
      </b-col>
    </b-form-row>
    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="reset"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="search"
      >
        Search
      </b-button>
    </div>
  </form>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import PositionsInput from '@/components/parts/inputItem/PositionsInput.vue';
import GendersInput from '@/components/parts/inputItem/GendersInput.vue';
import YearMonthInput from '@/components/parts/inputItem/YearMonthInput.vue';
import moment, { Moment } from 'moment'
import _ from 'lodash';
import { Position } from '@/store/master/types';
import { ExtraConditions } from '@/store/extras/types'

export interface ExtraSearchConditions {
  tutorNameOrId: string|null
  positions: Position[]
  yearMonth: Moment
}

@Component({
  components: {
    PositionsInput,
    GendersInput,
    YearMonthInput,
  },
})
export default class ExtraSearch extends Vue {
  private conditions: ExtraConditions = {
    tutorNameOrId: null,
    positions: [],
    yearMonth: moment().startOf('month'),
  }

  /**
   * 検索
   */
  search() {
    this.$emit('search', this.conditions)
  }

  /**
   * 検索条件リセット
   */
  reset() {
    this.conditions = {
      tutorNameOrId: null,
      positions: [],
      yearMonth: moment().startOf('month'),
    }
    this.search()
  }
}
</script>
